var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
class NoCacheMiddleware {
  static applySettings(settings) {
    return Promise.resolve(
      EnvironmentService.enableUnifiedNoCacheMiddleware() ? __spreadProps(__spreadValues({}, settings), {
        headers: __spreadProps(__spreadValues({}, settings.headers), {
          "Cache-Control": "no-cache"
        })
      }) : settings
    );
  }
  static getMiddleware() {
    return (settings, next) => __async(this, null, function* () {
      const newSettings = yield this.applySettings(settings);
      return next(newSettings);
    });
  }
}
function noCache() {
  return (constructor) => {
    const nc = class extends constructor {
      constructor(...args) {
        super(...args);
        this.addMiddleWare(NoCacheMiddleware.getMiddleware());
      }
    };
    return nc;
  };
}
export {
  NoCacheMiddleware,
  noCache
};
//# sourceMappingURL=NoCacheMiddleware.js.map
